<template>
  <div>
    <sidepanel
      id="panel-client"
      @open="init"
      @close="client = null"
      :processing="processing"
      :title="client ? client.name : '...'"
      :save="save"
    >
      <div v-if="client">
        <base-input label="Name" v-model="client.name" />
        <base-input label="Internal ID" v-model="client.internalId" />
        <base-input
          label="Born (year)"
          type="number"
          v-model="client.birthYear"
        />
        <div class="base-input">
          <label for="client-sex">Sex</label>
          <select v-model="client.sex" id="client-sex">
            <option value="" disabled>Select...</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <template v-if="client.id">
          <base-input label="BWID" v-model="client.id" :disabled="true" />
          <button @click="deleteClient(client)" class="transparent">
            <v-icon name="trash" />
          </button>
        </template></div
    ></sidepanel>
  </div>
</template>

<script>
export default {
  data() {
    return {
      client: null,
      processing: false
    };
  },
  props: {
    deleteClient: {
      type: Function
    }
  },
  methods: {
    async init() {
      const clientId = this.$store.getters.sidepanel("panel-client").payload
        .clientId;
      if (!clientId) {
        this.client = {};
        return;
      }
      this.processing = true;
      const clientData = await this.$store.dispatch(
        "ClientsStore/get",
        clientId
      );
      this.processing = false;
      this.client = clientData;
    },
    async save() {
      this.processing = true;
      if (this.client.id) {
        await this.$store.dispatch("ClientsStore/save", this.client);
      } else {
        await this.$store.dispatch("ClientsStore/add", this.client);
      }
      this.removePanel();
      this.processing = false;
    }
  }
};
</script>
